import { getStoreBuilder } from "vuex-typex";
import { InboxState } from "./modules/inbox";
import { SnackState } from "./modules/snack";

export interface RootState {
  inbox: InboxState;
  snack: SnackState;
}

export const storeBuilder = getStoreBuilder<RootState>();
